<template>
  <Layout>
    <div :class="$style.sectionPrice">
      <div class="container">
        <div class="dingbeauty-banner-content ">
          <p class="sub-title">Pricing</p>
          <h1 class="title">方案價格</h1>
          <div class="description">
            <p>拿出您的現有電腦，立即開始輕鬆管理！</p>
            <p>我們提供多種使用方案，讓店家能多元選擇，</p>
            <p>不管是個人工作室還是多店連鎖品牌，愛美訂都能提供您最合適的系統方案！</p>
            <p>從最初引進系統使用開始，到未來出現任何問題，愛美訂都會在這裡為您服務！</p>
          </div>
        </div>
      </div>
    </div>
    <DingBeautyPlans :title="`<h1 class='plans-title'>依照不同規模的美容店，愛美訂為您貼身訂製最適合的方案</h1>`"></DingBeautyPlans>
    <!-- <SectionCompare></SectionCompare> -->
    <DingBeautyHelp></DingBeautyHelp>
  </Layout>
</template>

<script>
import Layout from '@layout/main'
import DingBeautyPlans from '@components/DingBeauty/DingBeautyPlans.vue'
import SectionCompare from './components/SectionCompare'
import DingBeautyHelp from '@src/components/DingBeauty/DingBeautyHelp.vue'

export default {
  page() {
    return {
      title: '方案價格',
    }
  },
  components: {
    Layout,
    DingBeautyPlans,
    SectionCompare,
    DingBeautyHelp,
  },
}
</script>

<style lang="scss" module>
.sectionPrice {
  position: relative;
  background-image: url('@assets/images/home/banner022.jpg');
  height: 100vh;
  background-size: cover;
  background-position: 78% center;

  // Darken background
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    display: inline-block;
    background-color: rgba($color: #000000, $alpha: 0.2);
    width: 100%;
    height: 100%;
  }
}

@media (min-width: 992px) {
  .sectionPrice {
    height: 700px;
    background-position: center;
  }
}
</style>

